function f(e, n) {
  for (var l = -1, t = e == null ? 0 : e.length; ++l < t && n(e[l], l, e) !== !1; )
    ;
  return e;
}
export {
  f as default
};
